import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const Type = ({ type }: SpecProps<"type">) => {
  const { i18n } = useLingui();

  if (!type) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.motorbike.type",
    message: "Type",
    comment: "Field for 'type' in motorbike ad specification",
  });
  return <FieldValuePair field={field} value={type} />;
};
